import '../../styles/index.sass';
import { defaultInitCode, requestInterval, webpackWorkAround } from '../utils';
import { MapController } from './map';
import { Kpi1View, Kpi2View, Kpi3View } from './kpi';
import { LegendController } from './legendController';
import { TagsController } from './TagsController';

document.addEventListener('DOMContentLoaded', () => {
  defaultInitCode();

  const host = CONFIG.host;
  const node = `/country/${CONFIG.country}`;

  const map = new MapController('map-wrap', swim.nodeRef(host, node) );
  const kpi1 = new Kpi1View('kpi-1', map, swim.nodeRef(host, node));
  const kpi2 = new Kpi2View('kpi-2', map, swim.nodeRef(host, node));
  const kpi3 = new Kpi3View('kpi-3');
  const legend = new LegendController('legend-wrap', map);
  const tags = new TagsController('legend-wrap', host, node, CONFIG.country, map, [kpi1, kpi2, kpi3]);

  const legendMenu = document.querySelector('.legend-wrap');
  legendMenu.querySelector('.legend-wrap .logo-wrap').addEventListener('click', (evt)=> {
    evt.preventDefault();
    legendMenu.classList.toggle('open');
    document.querySelector('.map-wrap').classList.toggle('open');
  });

  legend.init();
  tags.init();
  requestInterval(()=> {
    kpi1.render();
    kpi2.render();
    kpi3.render();
    map.render();
  }, 0);


  const elem = document.querySelector('.legend-wrap .timer');
  if(elem) {
    setInterval(function() {
      const date = new Date(); // your logic string for date
      const locale = date.toLocaleString();
      // const format = locale.replace(/\//g, '.').replace(/,/g, '');
      elem.innerText = locale;
    }, 1000);
  }

});

// REMOVE Work around webpack
webpackWorkAround();
